import { PairName } from '@ui/assets/config/trade-pair-listings';
import { tryReportError } from '@ui/lib/bugsnag';
import { getTradingReaderFacet } from '@ui/services/contract/contract-instances/getTradingReaderFacet';
import { ChainId } from '@ui/types/chain';
import { BareTradePair } from '@ui/types/tradePair';
import { Address, PublicClient, zeroAddress } from 'viem';

import { toPosition } from '../useGetPositionV3/toPosition';
import { ContractPositionV3, Position } from '../useGetPositionV3/types';

export const GET_POSITIONS_V3_BATCH = 'TradingReaderFacet.getPositionsV4.batch';

export const getPositionsV3BatchQuery = {
  getQueryKey: ({
    chainId,
    pairs,
    user,
  }: {
    chainId: number;
    user: Address;
    pairs: Record<PairName, BareTradePair> | undefined;
  }) => [
    GET_POSITIONS_V3_BATCH,
    chainId,
    user,
  ],
  getQueryFn:
    ({
      pairs,
      user,
      client,
      chainId,
    }: {
      user: Address;
      pairs: Record<PairName, BareTradePair> | undefined;
      client?: PublicClient;
      chainId: ChainId;
    }) =>
    async (): Promise<Position[]> => {
      if (!client) {
        throw new Error('Client missing');
      }
      const contract = getTradingReaderFacet({
        publicClient: client,
        chainId,
      });

      const result = await contract.read.getPositionsV4([user, zeroAddress]);

      const baseToPair = Object.fromEntries(
        Object.entries(pairs ?? {}).map(([, value]) => [
          value.address,
          value,
        ]),
      );

      return result
        .map((p) => {
          const pair = baseToPair[p.pairBase.toLowerCase()];

          if (!pair) {
            tryReportError(
              new Error(`pairBase ${p.pairBase} is not found in pair config`),
            );

            return null;
          }

          return toPosition({
            position: p as ContractPositionV3,
            chainId,
            pair,
            user,
          });
        })
        .filter((p): p is Position => !!p);
    },
};


